import PropTypes from 'prop-types';
import classNames from 'classnames';

import materialIcons from './materialIcons';

import styles from './DSIcon.module.scss';

const DSIcon = ({ name, title = '', className = '', size = 'm' }) => {
  const { name: iconName, fill, negative } = materialIcons[name] || {};
  const iconClassName = classNames(
    className,
    styles['ds-icon'],
    styles[`ds-icon--${size}`],
    {
      [styles['ds-icon--negative']]: negative
    }
  );

  const style = fill
    ? {
        fontVariationSettings: "'FILL' 1" // keep double quotes
      }
    : {};
  return (
    <i
      className={classNames(iconClassName, 'notranslate')}
      title={title}
      style={style}
      data-icon={iconName}
      translate="no"
    >
      {iconName}
    </i>
  );
};

DSIcon.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['s', 'sm', 'm', 'ml', 'l', 'xl'])
};

export default DSIcon;
